<template>
  <el-dialog :title="title" class="page-form-dialog" v-bind="$attrs" v-on="$listeners" >
    <slot/>
    <div slot="footer">
      <el-button type="primary" :disabled="loading" @click="confirm">{{$t('common.confirm')}}</el-button>
      <el-button :disabled="loading" @click="cancel">{{$t('common.cancel')}}</el-button>
    </div>
  </el-dialog>
</template>
<script setup>
import { defineProps, defineEmits } from 'vue';
defineProps({
  title: {
    type: String,
    default: ''
  },
  loading: {
    type: Boolean,
    default: false
  }
})
const emits = defineEmits(['cancel', 'confirm'])
const cancel = (e) => emits('cancel', e)
const confirm = (e) => emits('confirm', e)

</script>

<style lang="scss">
.page-form-dialog{
  .el-dialog__footer{
    margin-top: 0;
  }
}
</style>